module.exports = __webpack_public_path__ + "static/media/blog_caro11.eafea74d.jpeg";